import { useState } from "react";
import Button from "components/common/controls/Button";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import ContactSalesPopup from "fetaures/contact-sales/ContactSalesPopup";
import { RootState } from "store/store";
import { getSelectedProductId } from "shared/utility/ProductSubscriptionHelper";
import { getConfiguration } from "shared/utility/ConfigUtility";
import { connect } from "react-redux";
import Link from "components/common/LinkButton";

interface Props {
  productId?: number;
  largeButton?: boolean;
  type?: "link" | "button";
}

export function ContactSalesFormWithButton(props: Props) {
  const [isContactSalesPopupVisible, setIsContactSalesPopupVisible] =
    useState(false);

  const { productId, largeButton, type } = props;

  const handlePopupClose = () => {
    setIsContactSalesPopupVisible(false);
  };

  const handleClick = () => {
    setIsContactSalesPopupVisible(true);
  };

  return (
    <>
      {type === "link" ? (
        <Link onClick={handleClick} className="text-primaryRed font-bold">
          contact sales
        </Link>
      ) : (
        <Button
          text="CONTACT SALES"
          radiusSize={ControlSize.Midium}
          onClick={handleClick}
          {...(largeButton
            ? { size: ControlSize.Large, className: "w-50" }
            : {})}
        />
      )}
      {isContactSalesPopupVisible && (
        <ContactSalesPopup onClose={handlePopupClose} productId={productId!} />
      )}
    </>
  );
}

const mapStateToProps = (state: RootState, props: Props) => {
  return {
    productId:
      getSelectedProductId(state) || getConfiguration("defaultProductId"),
    ...props,
  };
};

export default connect(mapStateToProps)(ContactSalesFormWithButton);
